import { createContext, useContext } from "react";
import {
  defaultModuleDataDto,
  type EnrolledProgram,
  type ModuleDataDto,
} from "./setupApi";

export type SelfLearnContextType = {
  dataDto: ModuleDataDto;
  handleLogOut?: () => void;
  env: string;
  /** Call after the user selects a course so API headers use that program's tenant / subtenant. */
  syncApiSessionForSelectedProgram: (
    program: EnrolledProgram & { program_id: string },
  ) => void;
};

const SelfLearnContext = createContext<SelfLearnContextType>({
  dataDto: defaultModuleDataDto,
  handleLogOut: undefined,
  env: "production",
  syncApiSessionForSelectedProgram: () => {},
});

export const SelfLearnProvider = SelfLearnContext.Provider;

export const useSelfLearnData = (): SelfLearnContextType =>
  useContext(SelfLearnContext);
